import './overrides.js';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { PostHogProvider } from 'posthog-js/react';
import { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { AppSettings } from './constants/AppSettings.js';
import { useLanguage } from './hooks/useLanguage.js';
import { dynamicActivate } from './locale/i18n.js';

function LocalizedApp() {
  const { language } = useLanguage();

  // Load translations
  useEffect(() => {
    dynamicActivate(language);
  }, [language]);

  return (
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider
      apiKey={AppSettings.postHog.apiKey}
      options={{
        api_host: AppSettings.postHog.host,

        // Essential SaaS settings (non-defaults)
        capture_exceptions: true,
        secure_cookie: AppSettings.env === 'production',
        cross_subdomain_cookie: true,

        // Session replay privacy (non-defaults)
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '[data-ph-mask]',
          blockSelector: '[data-ph-no-capture]',
        },

        // Custom initialization
        loaded: posthog => {
          posthog.register({
            app_version: AppSettings.version || 'unknown',
            environment: AppSettings.env,
          });
        },
      }}
    >
      <ErrorBoundary>
        <LocalizedApp />
      </ErrorBoundary>
    </PostHogProvider>
  </StrictMode>,
);
